import type { Logger } from '@vp/ubik-logging'

import type { Project } from '../../types/Project'

/**
 * Handles navigation after successful add to cart
 *
 * @param projects - Array of projects
 * @param nextStepUrl - URL template for the next step
 */
export function navigateToNextStep(projects: Project[], nextStepUrl: string, logger: Logger): void {
  if (projects[0]) {
    const nextStepPath = nextStepUrl.replace('{workId}', projects[0].workId)
    navigate(nextStepPath)
  } else {
    logger.error('No projects found to navigate to next step.')
  }
}

const navigate = (url: string): void => {
  window.location.href = url
}
